import React, { useState, useEffect } from "react";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";

const CompanySelector = ({ SelectedSupplier, setSelectedSupplier }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [SearchText, setSearchText] = useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "my-popover" : undefined;

  const dispatch = useDispatch();
  const Suppliers = useSelector((state) => state.Suppliers);

  useEffect(() => {
    dispatch(fetchSuppliers());
  }, [dispatch]);

  return (
    <div className="flex flex-col px-0 gap-y-4">
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        className="relative text-left cursor-pointer transition-colors ease-in-out duration-200 border border-line hover:border-main bg-card text-ink px-4 py-3 rounded-lg font-quicksand font-bold text-sm flex gap-x-6 items-center active:scale-[.99]"
        onClick={handleClick}
      >
        <div className="flex items-center justify-between w-full">
          <div className="w-full outline-none font-semibold text-sm text-left text-ink bg-transparent">
            {SelectedSupplier === ""
              ? "Select Company"
              : SelectedSupplier?.name}
          </div>
          <BiSolidChevronDown className="text-xl text-muted shrink-0" />
        </div>
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            width: anchorEl ? anchorEl.offsetWidth : "auto",
            overflow: "hidden",
            marginTop: "6px",
            boxShadow:
              "0 4px 12px rgba(16,69,70,0.08), 0 12px 28px rgba(16,69,70,0.08)",
            border: "1px solid #E5E9EB",
            maxHeight: "50vh",
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="bg-card text-ink font-quicksand p-2 flex flex-col">
          <input
            type="text"
            placeholder="Search company"
            aria-label="Search company"
            className="w-full px-3 py-2 rounded-lg border border-line bg-card text-ink placeholder:text-muted text-sm outline-none focus:border-main focus:ring-2 focus:ring-main/15 mb-2"
            value={SearchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <div className="flex flex-col gap-y-0.5 max-h-[40vh] overflow-y-auto scrollable">
            {Suppliers.data &&
              Suppliers.data
                .filter((customer) =>
                  SearchText === ""
                    ? true
                    : customer.name
                        .toLowerCase()
                        .includes(SearchText.toLowerCase())
                )
                .map((customer) => {
                  const active = SelectedSupplier?._id === customer._id;
                  return (
                    <button
                      type="button"
                      key={customer._id}
                      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm font-semibold transition-colors ${
                        active
                          ? "bg-brandSoft text-main"
                          : "text-inkSecondary hover:bg-subtle"
                      }`}
                      onClick={() => {
                        setSelectedSupplier(customer);
                        handleClose();
                      }}
                    >
                      <span
                        className={`h-4 w-4 shrink-0 rounded-full border-2 ${
                          active
                            ? "border-main bg-main"
                            : "border-line bg-card"
                        }`}
                      />
                      <span className="truncate">{customer.name}</span>
                    </button>
                  );
                })}
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default CompanySelector;
